<template>
  <div class="game">
    <!-- <div :class="game_music_on?'music_box music_rotate':'music_box'" :style="{backgroundImage: musicImgUrl, backgroundSize:'cover',backgroundRepeat:'no-repeat',backgroundPosition:'center'}" @click="gameMp3Control"></div> -->

    <div class="game-road">
      <!-- 水流 -->
      <div class="game-bg" :class="quickScroll?'':'normal-scroll'" ref="scrollWater"></div>
      <div class="road-left">
        <div class="left-2" :class="slideWater?'slide-water-2':''"></div>
        <div class="left-waterfall" :class="slideWater?'slide-water':''"></div>
        <div class="game-left"></div>
      </div>
      <div class="road-right">
        <div class="right-waterfall"></div>
        <div class="right-2" :class="slideWater?'slide-water':''"></div>
        <div class="game-right"></div>
        <div class="game-right-2" :class="slideWater?'slide-water-2':''"></div>
        <div class="tea-right"></div>
      </div>
      <!-- 倒计时 -->
      <div class="progress-con">
        <div class="time">
          <div class="time-num">
            <b>{{totalTime}}</b>
          </div>
        </div>
        <div class="progress-bar">
          <div class="progress-main" :style="'width:' + progressWidth + '%'" ref="progressWidth">
            <div class="progress-icon">
              <!-- 滑行记录 -->
              <div class="current-hits" ref="hitNum">{{HitNumber}}米</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 击鼓 -->
      <div class="big-click" @touchstart="isTouch&&hitDrum()" @touchend="relaseHit">
        <div class="game-drum">
          <!-- <div style="color:red; font-size: 0.5rem; position: absolute; top:-1.5rem">{{HitNumber}}</div> -->
          <div class="drum-face" ref="drumFace"></div>
          <div class="left-drumstick"></div>
          <div class="right-drumstick"></div>
          <div class="drum-text"></div>
        </div>
      </div>
      <!-- 三条船 -->
      <div class="boat-left" :class="slideWater?'boat-row':''"></div>
      <div class="boat-right" :class="slideWater?'boat-row-2':''"></div>
      <div class="boat-main" :style="{bottom: mainBoatPosition+'rem'}" ref="boatMain">
        <div class="gamer-avatar">
          <img src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1591790805630&di=fd65e157eb91e5d20b5c0352684890d0&imgtype=0&src=http%3A%2F%2Fadmin.anzow.com%2Fpicture%2F2012418%2F2012041810194675.png" alt />
        </div>
      </div>

      <!-- 按时间出现的粽子、小罐子、礼盒 -->
      <div class="small-zz" ref="zz"></div>
      <div class="small-gz" ref="gz"></div>
      <div class="big-zz" ref="bigZz"></div>
      <div class="gold-zz" ref="goldZz"></div>
      <div class="gift" ref="gift"></div>
      <div class="gift-left" ref="leftGift"></div>
      <!-- 蒙版 -->
      <div class="masking" v-show="threeToOne > 0">
        <div class="three-to-one">
          <div class="number-1" v-show="threeToOne == 1"></div>
          <div class="number-2" v-show="threeToOne == 2"></div>
          <div class="number-3" v-show="threeToOne == 3"></div>
        </div>
        <div class="drum-start" v-show="threeToOne < 4"></div>
      </div>
      <!-- 弹窗蒙版 -->
      <div class="masking" v-show="showModal || showHaveAwardModal || BugModal"></div>
      <!-- 弹窗 -->
      <div class="game-modal show" v-show="showModal">
        <div class="model-top">
          <!-- <div class="modal-close" @click="closeModal"></div> -->
        </div>
        <div class="model-main">
          <div>安康！</div>
          <div>您当前滑行距离为{{HitNumber}}米</div>
          <div class="to-ranklist" @click="toRankList"></div>
        </div>
        <div class="model-bottom"></div>
      </div>
      <!-- 已经获奖的弹窗 -->
      <div class="game-modal show" v-show="showHaveAwardModal">
        <div class="model-top">
          <!-- <div class="modal-close" @click="closeHaveAwardModal"></div> -->
        </div>
        <div class="model-main">
          <div>
            由于您已喜提奖品
            <br />本次击鼓记录将不计入排名中
          </div>
          <div class="to-ranklist" @click="toRankList"></div>
        </div>
        <div class="model-bottom"></div>
      </div>
      <!-- 作弊的弹窗 -->
      <div class="game-modal show" v-show="BugModal">
        <div class="model-top">
          <!-- <div class="modal-close" @click="closeHaveAwardModal"></div> -->
        </div>
        <div class="model-main">
          <div>系统监测到您的操作存在干扰行为，本次游戏将不计入排名</div>
          <div class="bug-modal" @click="toIndex"></div>
        </div>
        <div class="model-bottom"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // game_music_on: true,   //背景音乐
      // musicImgUrl: "url(" + require("../../assets/H5img/music_on.png") + ")",
      slideWater: false,
      totalTime: 30, //限制时间
      progressWidth: 0, //进度条
      HitNumber: 0, //敲击总数
      threeToOne: 3, //游戏开始前倒计时
      showModal: false, //游戏结束弹窗
      showHaveAwardModal: false, //已经获奖的弹窗
      quickScroll: false,
      mainBoatPosition: 4,
      lastTime: undefined,
      flag: "",
      timer: null,
      ranklist: [],
      avatar: "", //用户头像
      isTouch: true,
      BugModal: false, //作弊弹窗
      lastRange: 0, //上一次的点击时差
      sameClick: 0
    };
  },
  watch: {
    totalTime(val) {
      if (val == 0) {
        this.isTouch = false;
      }
    }
  },
  methods: {
    //游戏音乐控制
    gameMp3Control() {
      if (this.game_music_on) {
        document.getElementById("myAudio2").pause();
        this.game_music_on = false;
        this.musicImgUrl =
          "url(" + require("../../assets/H5img/music_off.png") + ")";
      } else {
        document.getElementById("myAudio2").play();
        this.game_music_on = true;
        this.musicImgUrl =
          "url(" + require("../../assets/H5img/music_on.png") + ")";
      }
    },
    hitDrum() {
      clearTimeout(this.timer);
      this.timer = null;
      let nowTime = new Date();
      // console.log(this.$refs.scrollWater.style.cssText == 'animation-duration: 2s;')
      // if(this.$refs.scrollWater.style.cssText == 'animation-duration: 6s;') {
      //     this.$refs.scrollWater.style.animationDuration = '2s'
      // }
      console.log(
        this.lastTime == undefined ||
          Math.round(nowTime.getTime() - this.lastTime.getTime()),
        "本次"
      );
      let timeRange =
        this.lastTime == undefined ||
        Math.round(nowTime.getTime() - this.lastTime.getTime()); //两次点击之间的时间差
      console.log(this.lastRange, "上次");
      if (timeRange == this.lastRange) {
        this.sameClick++;
        console.log(this.sameClick);
      }
      this.lastRange = timeRange;
      if (
        this.lastTime == undefined ||
        Math.round(nowTime.getTime() - this.lastTime.getTime()) > 1000
      ) {
        //判断两次点击之间的时间差
        this.lastTime = nowTime;
        this.flag = 1;
      } else {
        this.lastTime = nowTime;
        this.flag = 0;
      }
      if (this.flag == 1) {
        this.$refs.scrollWater.style.animationDuration = "2s";
        this.lastTime = nowTime;
        this.flag = 1;
      }
      this.$refs.drumFace.style.top = `-0.1rem`;
      let random = this.getRandom(0, 0.2, 2);
      this.HitNumber++;
      this.HitNumber = (this.HitNumber * 1 + random * 1).toFixed(1);
      this.$refs.boatMain.style.backgroundPosition = `0 0rem`;
      this.mainBoatPosition += 0.012; //调整船向上的速度
    },
    relaseHit() {
      if (this.$refs.scrollWater.style.cssText == "animation-duration: 2s;") {
        this.timer = setTimeout(() => {
          this.$refs.scrollWater.style.animationDuration = "6s";
        }, 300);
      }
      this.$refs.drumFace.style.top = `0.1rem`;
      this.$refs.boatMain.style.backgroundPosition = `-0.02rem 3.2rem`;
    },
    //游戏开始倒计时，结束后把数据传到后台
    startTime() {
      if (this.totalTime > 0) {
        let timer = setInterval(() => {
          let totalTime = this.totalTime;
          if (totalTime > 0) {
            this.progressWidth += 100 / 30;
            this.totalTime--;
            if (totalTime == 10) {
              this.$refs.hitNum.style.color = "red";
            }
            if (totalTime == 11) {
              this.$refs.bigZz.classList.add("slide-zz"); //大粽子-右侧
            }
            if (totalTime == 14) {
              this.$refs.leftGift.classList.add("slide-gz"); //礼盒-左侧
            }
            if (totalTime == 17) {
              this.$refs.gift.classList.add("slide-zz"); //礼盒-右侧
            }
            if (totalTime == 21) {
              this.$refs.goldZz.classList.add("slide-zz"); //金罐子-左
            }
            if (totalTime == 24) {
              this.$refs.gz.classList.add("slide-zz"); //小罐子-右
            }
            if (totalTime == 27) {
              this.$refs.zz.classList.add("slide-zz"); //小粽子-左
            }
          } else {
            window.clearInterval(timer);
            let HitNumber = this.HitNumber;
            // let random = this.getRandom(1, 10, 1)
            // this.HitNumber = HitNumber * 1 + random * 1
            if (HitNumber > 800 || this.sameClick > 50) {
              this.BugModal = true;
            } else {
              //生成一条游戏记录
              this.sendRecord(this.HitNumber);
            }
            this.$refs.bigZz.style.display = "none";
            this.$refs.leftGift.style.display = "none";
            this.$refs.gift.style.display = "none";
            this.$refs.goldZz.style.display = "none";
            this.$refs.gz.style.display = "none";
            this.$refs.zz.style.display = "none";
          }
        }, 800);
      } else {
        console.log(this.isTouch);
      }
    },
    //生成用户本次击鼓记录
    sendRecord(num) {
      this.showModal = true;
      let openId = localStorage.getItem("openId");
      let userHeadImgUrl = localStorage.getItem("avatar");
      let nickname = localStorage.getItem("username");
      this.$axios
        .post(
          "/h5/api/createUser",
          {
            openId: openId,
            userHeadImgUrl: userHeadImgUrl,
            nickname: nickname,
            num: num
          },
          {}
        )
        .then(res => {
          let record = res.data.data.user;
          let ranklist = res.data.data.List;
          this.ranklist = ranklist;
          localStorage.setItem("gameNum2", record.game_num);
          if (res.data.code == 0) {
            if (record.is_win == 1) {
              this.showHaveAwardModal = true;
            } else {
              this.showModal = true;
            }
          } else {
            let record = res.data.data.user;
            if (user.is_win == 1) {
              this.showHaveAwardModal = true;
            }
          }
        });
    },
    //跳转排行榜
    toRankList() {
      // document.getElementById('myAudio2').pause()
      // document.getElementById('myAudio').play()
      this.$router.replace({
        path: "/Mrank"
      });
    },
    toIndex() {
      this.$router.replace({
        path: "/Mindex"
      });
    },
    //关闭弹窗
    closeModal() {
      if (this.showModal) {
        this.showModal = false;
      } else {
        this.showModal = true;
      }
    },
    //关闭已获奖弹窗
    closeHaveAwardModal() {
      if (this.showHaveAwardModal) {
        this.showHaveAwardModal = false;
      } else {
        this.showHaveAwardModal = true;
      }
    },
    // 随机数
    getRandom(start, end, fixed = 0) {
      let differ = end - start;
      let random = Math.random();
      return (start + differ * random).toFixed(fixed);
    },
    //设置分享
    setWxShare() {
      let openId = localStorage.getItem("openId");
      let avatar = localStorage.getItem("avatar");
      let username = localStorage.getItem("username");
      // let shareUrl = `https://smalltea.xiaoxxx.cn/#/Msupport?myopenid=${openId}&myavatar=${avatar}&myname=${username}`
      let shareUrl = `https://smalltea.xiaoxxx.cn/#/Msupport?myopenid=${openId}`;
      console.log(shareUrl);
      // shareUrl = "http://test.smalltea.xiaoxxx.cn/#/Msupport?myopenid=123&myavatar=888"
      // alert(shareUrl)
      // 微信分享
      window.wx.ready(() => {
        // 分享好友
        window.wx.updateAppMessageShareData({
          title: "乘风破浪·粽享端午", // 分享标题
          desc: "快来助力好友瓜分小罐茶3万大奖吧！", // 分享描述
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
          success: function() {
            console.log(url);
            // 设置成功
            // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享好友次数', '分享好友次数', '1', '1']);
          }
        });
        // 分享朋友圈
        window.wx.updateTimelineShareData({
          title: "乘风破浪·粽享端午", // 分享标题
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
          success: function() {
            // 设置成功
            window._czc.push([
              "_trackEvent",
              "祝福语页面分享--微信",
              "分享朋友圈次数",
              "分享朋友圈次数",
              "1",
              "1"
            ]);
          }
        });
        // 1.2.0 老接口
        wx.onMenuShareAppMessage({
          title: "乘风破浪·粽享端午", // 分享标题
          desc: "快来助力好友瓜分小罐茶3万大奖吧！", // 分享描述
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
          success: function() {
            // 设置成功
            // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享好友次数', '分享好友次数', '1', '1']);
          }
        });
        wx.onMenuShareTimeline({
          title: "乘风破浪·粽享端午", // 分享标题
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
          success: function() {
            // 设置成功
            window._czc.push([
              "_trackEvent",
              "祝福语页面分享--微信",
              "分享朋友圈次数",
              "分享朋友圈次数",
              "1",
              "1"
            ]);
          }
        });
      });
    }
  },
  created() {
    this.avatar = localStorage.getItem("avatar");
    this.setWxShare();
    setTimeout(() => {
      this.slideWater = true;
    }, 2000);
  },
  mounted() {
    // if (this.game_music_on) {
    //     this.musicImgUrl = "url(" + require("../../assets/H5img/music_on.png") + ")";
    // } else {
    //     this.musicImgUrl =
    //         "url(" + require("../../assets/H5img/music_off.png") + ")";
    // }
    let start_timer = setInterval(() => {
      if (this.threeToOne > 0) {
        this.threeToOne--;
        if (this.threeToOne == 1) {
          setTimeout(() => {
            this.startTime();
          }, 500);
        }
      } else {
        window.clearInterval(start_timer);
      }
    }, 1000);
  }
};
</script>

<style scoped>
.game {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  user-select: none;
}

.game-road {
  overflow: hidden;
  position: relative;
  height: 100%;
  transform-style: preserve-3d;
  width: 100%;
  background: url("../../assets/H5img/game/game-bg2.jpg");
  background-size: cover;
  background-position: center;
}

.game-bg {
  width: 7.5rem;
  height: 100%;
  background: url("../../assets/H5img/game/line.png");
  background-position: center center;
  background-size: contain;
}

.normal-scroll {
  animation: bgScroll 6s linear infinite;
}

/* .game-bg {
    overflow: hidden;
    position: relative;
    background-image: url('../../assets/H5img/game/line.png');
    background-position: center center;
    background-size: 7.5rem;
    position: absolute;
    top: -300%;
    left: 0;
    height: 400%;
    width: 100%;
    z-index: 1;
    -webkit-animation: scrollGood 5s linear infinite;
    -moz-animation: scrollGood 5s linear infinite;
    animation: scrollGood 5s linear infinite;
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -ms-backface-visibility: hidden;
    backface-visibility: hidden;
    -webkit-perspective: 1000;
    -moz-perspective: 1000;
    -ms-perspective: 1000;
    perspective: 1000;
} */

@keyframes bgScroll {
  0% {
    background-position: 0 0;
  }

  100% {
    background-position: 0 811px;
  }
}

@keyframes scrollGood {
  0% {
    transform: translate3d(0, 0, 0);
  }

  100% {
    transform: translate3d(0, 692px, 0);
  }
}

.road-left {
  position: absolute;
  top: 0;
  left: 0;
}

.left-waterfall {
  position: absolute;
  left: 0;
  top: 0;
  width: 0.89rem;
  height: 16.23rem;
  background: url("../../assets/H5img/game/game-right-water.png");
  background-size: cover;
  background-position: left;
}

.left-2 {
  position: absolute;
  left: 0;
  top: 0;
  width: 0.87rem;
  height: 14.79rem;
  background: url("../../assets/H5img/game/game-left-2.png");
  background-size: cover;
  background-position: left;
}

.game-left {
  position: absolute;
  left: 0;
  top: 0;
  width: 1.05rem;
  height: 16.24rem;
  background: url("../../assets/H5img/game/game-left.png");
  background-size: cover;
  background-position: left;
}

.road-right {
  position: absolute;
  top: 0;
  right: 0;
}

.right-2 {
  position: absolute;
  right: 0;
  top: 0;
  width: 0.96rem;
  height: 16.22rem;
  background: url("../../assets/H5img/game/game-left-water.png");
  background-size: cover;
  background-position: left;
  z-index: 3;
}

.right-waterfall {
  position: absolute;
  right: 0;
  top: 0;
  width: 0.6rem;
  height: 16.24rem;
  background: url("../../assets/H5img/game/right-light-water.png");
  background-size: cover;
  background-position: left;
  z-index: 4;
}

.game-right {
  position: absolute;
  right: 0;
  top: 3.76rem;
  width: 1.15rem;
  height: 6.52rem;
  background: url("../../assets/H5img/game/game-right.png");
  background-size: cover;
  background-position: right;
  z-index: 2;
}

.game-right-2 {
  position: absolute;
  right: 0;
  top: 1.44rem;
  width: 0.94rem;
  height: 14.8rem;
  background: url("../../assets/H5img/game/game-right-2.png");
  background-size: cover;
  background-position: right;
  z-index: 1;
}

.tea-right {
  position: absolute;
  right: 0;
  top: 8rem;
  width: 0.61rem;
  height: 1.2rem;
  background: url("../../assets/H5img/game/tea-right.png");
  background-size: cover;
  background-position: right;
  z-index: 4;
}

.slide-water {
  animation: slide-water 0.7s ease-in-out infinite alternate;
}

.slide-water-2 {
  animation: slide-water-2 0.8s ease-in-out infinite alternate;
}

@keyframes slide-water {
  from {
    transform: translate3d(0, -0.4rem, 0);
  }

  to {
    transform: translate3d(0, 0rem, 0);
  }
}

@keyframes slide-water-2 {
  from {
    transform: translate3d(0, 0rem, 0);
  }

  to {
    transform: translate3d(0, 0.5rem, 0);
  }
}

.big-click {
  position: absolute;
  bottom: 8%;
  left: 0;
  width: 7.55rem;
  height: 2.5rem;
  z-index: 3;
}

.game-drum {
  position: absolute;
  bottom: 8%;
  left: 50%;
  transform: translateX(-50%);
  width: 2.2rem;
  height: 2.35rem;
  background: url("../../assets/H5img/game/game-drum.png");
  background-size: cover;
  background-position: center;
}

.drum-face {
  position: absolute;
  top: 0.1rem;
  left: 50%;
  margin-left: -0.895rem;
  width: 1.73rem;
  height: 1.73rem;
  background: url("../../assets/H5img/game/drum-face.png");
  background-size: cover;
  background-position: center;
}

.left-drumstick {
  position: absolute;
  top: 0.8rem;
  left: -0.2rem;
  width: 0.76rem;
  height: 1.2rem;
  background: url("../../assets/H5img/game/left-stick.png");
  background-size: cover;
  background-position: center;
}

.right-drumstick {
  position: absolute;
  top: 0.8rem;
  right: -0.2rem;
  width: 0.76rem;
  height: 1.2rem;
  background: url("../../assets/H5img/game/right-stick.png");
  background-size: cover;
  background-position: center;
}

.drum-text {
  position: absolute;
  top: 0.4rem;
  left: 50%;
  transform: translateX(-50%);
  width: 0.44rem;
  height: 0.99rem;
  background: url("../../assets/H5img/game/click-me.png");
  background-size: cover;
  background-position: center;
}

.progress-con {
  position: absolute;
  display: flex;
  align-items: center;
  width: 5.9rem;
  height: 1.25rem;
  top: 0.55rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
}

.time {
  width: 1.26rem;
  height: 1.26rem;
  margin-left: 0.05rem;
  background: url("../../assets/H5img/game/time-circle.png");
  background-size: cover;
  background-position: center;
}

.progress-bar {
  position: relative;
  width: 4.16rem;
  height: 0.48rem;
  border-radius: 0.48rem;
  border: 3px solid #ffdebe;
  background: #ffffff;
  margin-left: 0.22rem;
}

.progress-main {
  width: 0%;
  height: 0.42rem;
  border-radius: 0.42rem;
  position: absolute;
  top: 50%;
  left: 0px;
  transform: translateY(-50%);
  background: url("../../assets/H5img/game/progress-main_03.png");
  background-size: cover;
  background-position: left;
  transition: 1000ms linear;
}

.time-num {
  color: #fcf9d4;
  /* border: 2px solid #d7673c; */
  font-size: 0.6rem;
  line-height: 1.26rem;
  text-align: center;
  /* letter-spacing: 2px; */
  font-weight: 900;
  -webkit-text-stroke: 2px #d56337;
  transition: 500ms ease-in-out;
}

.progress-icon {
  position: absolute;
  right: -0.6rem;
  top: -50%;
  width: 1.03rem;
  height: 0.84rem;
  /* transform: translateX(-50%); */
  background: url("../../assets/H5img/game/progress-icon.png");
  background-size: cover;
  background-position: left;
}

.boat-left {
  position: absolute;
  left: 1.23rem;
  bottom: 10%;
  width: 0.92rem;
  height: 2.1rem;
  /* width: 91px;
    height: 210px; */
  background: url("../../assets/H5img/game/boat-left.png");
  background-size: 100% auto;
  background-position: 0 0;
  z-index: 2;
}

.boat-row {
  animation: boat 0.4s steps(1) 0s infinite;
}

@keyframes boat {
  0% {
    background-position: 0px 0px;
  }

  50% {
    background-position: 0px -2.39rem;
  }

  100% {
    background-position: 0px 0px;
  }
}

.boat-right {
  position: absolute;
  right: 1.23rem;
  bottom: 10%;
  width: 0.83rem;
  height: 2rem;
  background: url("../../assets/H5img/game/boat-right.png");
  background-size: 100% auto;
  background-position: 0 0;
  z-index: 2;
}

@keyframes boat2 {
  0% {
    background-position: 0px 0px;
  }

  50% {
    background-position: 0px -2.34rem;
  }

  100% {
    background-position: 0px 0px;
  }
}

.boat-row-2 {
  animation: boat2 0.4s steps(1) 0s infinite;
}

.boat-main {
  position: absolute;
  left: 50%;
  bottom: 4.5rem;
  width: 1.95rem;
  height: 3.19rem;
  margin-left: -0.9rem;
  background: url("../../assets/H5img/game/boat-main.png");
  background-size: 100% auto;
  background-position: 0 3.2rem;
  z-index: 6;
}

.current-hits {
  position: absolute;
  bottom: -0.5rem;
  left: 0.1rem;
  width: 100%;
  /* transform: translateX(-50%); */
  font-size: 0.26rem;
  animation: pause 1s ease-in-out alternate infinite;
}

@keyframes pause {
  0% {
    transform: scale3d(1, 1, 1);
  }

  50% {
    transform: scale3d(1.1, 1.1, 1.1);
  }

  100% {
    transform: scale3d(1, 1, 1);
  }
}

.gamer-avatar {
  position: absolute;
  width: 0.8rem;
  height: 0.8rem;
  /* background: red; */
  top: -0.85rem;
  left: 48%;
  transform: translateX(-50%);
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #ffffff;
}

.gamer-avatar img {
  width: 100%;
  border-radius: 50%;
}

.masking {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10;
}

.three-to-one {
  position: absolute;
  top: 4rem;
  left: 50%;
  transform: translateX(-50%);
  width: 4.2rem;
  height: 3.4rem;
  text-align: center;
}

.number-1 {
  width: 1.54rem;
  height: 2.66rem;
  margin: 0 auto;
  background: url("../../assets/H5img/game/1.png");
  background-size: cover;
  background-position: center;
}

.number-2 {
  width: 1.92rem;
  height: 2.69rem;
  margin: 0 auto;
  background: url("../../assets/H5img/game/2.png");
  background-size: cover;
  background-position: center;
}

.number-3 {
  width: 1.79rem;
  height: 2.69rem;
  margin: 0 auto;
  background: url("../../assets/H5img/game/3.png");
  background-size: cover;
  background-position: center;
}

.drum-start {
  position: absolute;
  width: 2.84rem;
  height: 2.95rem;
  left: 50%;
  bottom: 15%;
  margin-left: -1.41rem;
  background: url("../../assets/H5img/game/drum-start.png");
  background-size: cover;
  background-position: center;
  animation: drum-start 1s ease-in-out infinite alternate;
}

@keyframes drum-start {
  0% {
    transform: scale3d(1, 1, 1);
  }

  50% {
    transform: scale3d(1.2, 1.2, 1.2);
  }

  100% {
    transform: scale3d(1, 1, 1);
  }
}

/* 弹窗 */
.game-modal {
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  z-index: 11;
}

.model-top {
  position: absolute;
  top: -2.2rem;
  left: 50%;
  transform: translateX(-50%);
  width: 6.02rem;
  height: 3.38rem;
  background: url("../../assets/H5img/model/model-top.png");
  background-size: cover;
  background-position: center;
}

.model-main {
  width: 5.03rem;
  /* height: 4.1rem; */
  padding: 0.9rem 0.65rem;
  background: #f2dbaa;
  border-radius: 0.3rem;
  font-size: 0.3rem;
  color: #31302e;
  line-height: 1.6;
  font-weight: 600;
}

.to-ranklist {
  width: 3.55rem;
  height: 0.92rem;
  margin: 0 auto;
  background: url("../../assets/H5img/model/to-ranklist.png");
  background-size: cover;
  background-position: center;
  margin-top: 0.4rem;
}
.bug-modal {
  width: 3.55rem;
  height: 0.92rem;
  margin: 0 auto;
  background: url("../../assets/H5img/game/back-index.png");
  background-size: cover;
  background-position: center;
  margin-top: 0.4rem;
}
.model-bottom {
  position: absolute;
  left: 50%;
  bottom: -0.6rem;
  transform: translateX(-50%);
  width: 5.31rem;
  height: 1.27rem;
  background: url("../../assets/H5img/model/model-cloud.png");
  background-size: cover;
  background-position: center;
}

.modal-close {
  position: absolute;
  top: 0;
  right: 0.1rem;
  width: 0.49rem;
  height: 0.48rem;
  background: url("../../assets/H5img/model/close-icon.png");
  background-size: cover;
  background-position: center;
}

.small-zz {
  position: absolute;
  top: -1rem;
  left: 1.4rem;
  width: 0.84rem;
  height: 0.75rem;
  background: url("../../assets/H5img/game/icon-1.png");
  background-size: cover;
  background-position: center;
  z-index: 1;
}

.slide-zz {
  animation: slide-zz 6s linear forwards;
}

.slide-gz {
  animation: slide-zz 5s linear forwards;
  animation-delay: 2s;
}

@keyframes slide-zz {
  from {
    top: -1rem;
  }

  to {
    top: 15rem;
  }
}

.small-gz {
  position: absolute;
  top: -1rem;
  right: 1.25rem;
  width: 0.96rem;
  height: 0.91rem;
  background: url("../../assets/H5img/game/icon-3.png");
  background-size: cover;
  background-position: center;
  z-index: 1;
}

.slide-gz {
  animation: slide-zz 8s linear forwards;
}

.big-zz {
  position: absolute;
  top: -1.2rem;
  right: 1.2rem;
  width: 1rem;
  height: 1rem;
  transform: rotate(30deg);
  background: url("../../assets/H5img/game/icon-2.png");
  background-size: cover;
  background-position: center;
  z-index: 1;
}

.gift {
  position: absolute;
  top: -1.2rem;
  right: 1.3rem;
  width: 1rem;
  height: 0.75rem;
  transform: rotate(0deg);
  background: url("../../assets/H5img/game/icon-5.png");
  background-size: cover;
  background-position: center;
  z-index: 1;
}

.gold-zz {
  position: absolute;
  top: -1rem;
  left: 1.4rem;
  width: 0.84rem;
  height: 0.75rem;
  background: url("../../assets/H5img/game/icon-4.png");
  background-size: cover;
  background-position: center;
  z-index: 1;
}

.gift-left {
  position: absolute;
  top: -1rem;
  left: 1.3rem;
  width: 1rem;
  height: 0.75rem;
  background: url("../../assets/H5img/game/icon-5.png");
  background-size: cover;
  background-position: center;
  z-index: 1;
}
</style>
